import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "assets/css/App.css";

import {
  HashRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";

import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import routes from "routes.js";

import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme";
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import UnauthorizedPage from "./Unauthorized";
import "./i18n";

// SOCKET PROVIDERS
import { OrdersProvider } from "contexts/OrdersContext";
import { UnseenOrdersProvider } from "contexts/UnseenOrdersContext";

if (process.env.REACT_APP_USE_MSW === "true") {
  // eslint-disable-next-line global-require
  const { worker } = require("./mocks/promo/browser");
  worker.start({ onUnhandledRequest: "bypass" });
}

const hasPermission = (pathname) => {
  const role_id = sessionStorage.getItem("role_id");

  // Super admin full access
  if (role_id === "1") return true;

  const role = JSON.parse(sessionStorage.getItem("permissions") || "{}");
  if (!role.permissions) return false;

  const currentRoute = routes.find(
    (route) =>
      route.layout === "/admin" &&
      pathname.startsWith(route.layout + route.path)
  );

  if (!currentRoute || !currentRoute.pageId) return false;

  return role.permissions.some(
    (permission) =>
      permission.page_access &&
      Number(permission.page_id) === Number(currentRoute.pageId)
  );
};

const RootRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");

    if (accessToken) {
      history.replace("/admin/Main Dashboard");
    } else {
      history.replace("/auth");
    }
  }, [history]);

  return null;
};

// -----------------------------
// MAIN RENDER
// -----------------------------
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ChakraProvider theme={theme}>
    <ThemeEditorProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <HashRouter>
          <Switch>
            <Route path="/auth/unauthorized" component={UnauthorizedPage} />

            {/* Auth Routes */}
            <Route path="/auth" component={AuthLayout} />

            {/* ADMIN ROUTES WRAPPED WITH PROVIDERS */}
            <Route
              path="/admin"
              render={(props) =>
                hasPermission(props.location.pathname) ? (
                  <OrdersProvider>
                    <UnseenOrdersProvider>
                      <AdminLayout {...props} />
                    </UnseenOrdersProvider>
                  </OrdersProvider>
                ) : (
                  <Redirect to="/auth/unauthorized" />
                )
              }
            />

            <Route exact path="/" component={RootRedirect} />

            <Redirect to="/auth" />
          </Switch>
        </HashRouter>
      </Suspense>
    </ThemeEditorProvider>
  </ChakraProvider>
);